import React from 'react';
import { Activity, Filter, ScrollText, MapPin, Map, Info } from 'lucide-react';

interface EventKPICardsProps {
    totalEvents: number;
    filteredEvents: number;
    totalMusterRolls: number;
    filteredMusterRolls: number;
    totalStates: number;
    totalDistricts: number;
    onStatesCardClick?: () => void;
}

export const EventKPICards: React.FC<EventKPICardsProps> = ({ totalEvents, filteredEvents, totalMusterRolls, filteredMusterRolls, totalStates, totalDistricts, onStatesCardClick }) => {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
            {/* Total Transactions Card */}
            {/* <div className="bg-brand-light rounded-lg p-4 border border-brand">
                <div className="flex items-center justify-between">
                    <div className="flex-1">
                        <p className="text-sm font-medium text-gray-600">Total Transactions</p>
                        <p className="text-3xl font-bold text-gray-900 mt-1">{totalEvents}</p>
                        <p className="text-base font-medium text-gray-500 mt-2">Filtered View: {filteredEvents}</p>
                    </div>
                    <div className="p-2 bg-brand-light rounded-lg">
                        <Activity className="w-6 h-6 text-brand" />
                    </div>
                </div>
            </div> */}

            {/* Total Muster Rolls Card */}
            <div className="bg-brand-light rounded-lg p-4 border border-brand">
                <div className="flex items-center justify-between">
                    <div className="flex-1">
                        <div className="flex items-center gap-1">
                            <p className="text-sm font-medium text-gray-600">Total Muster Rolls</p>
                            <div className="group relative inline-block">
                                <Info className="w-4 h-4 text-gray-500 cursor-help hover:text-gray-700 transition-colors" />
                                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block z-50 pointer-events-none">
                                    <div className="bg-gray-900 text-white text-xs rounded-lg py-2 px-3 w-64 shadow-xl">
                                        <p>Represents the total number of muster rolls for which attendance has been recorded. The filtered view shows the count based on the current selections applied.</p>
                                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
                                            <div className="border-4 border-transparent border-t-gray-900"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p className="text-3xl font-bold text-gray-900 mt-1">{totalMusterRolls}</p>
                        <p className="text-base font-medium text-gray-500 mt-2">Filtered View: {filteredMusterRolls}</p>
                    </div>
                    <div className="p-2 bg-brand-light rounded-lg">
                        <ScrollText className="w-6 h-6 text-brand" />
                    </div>
                </div>
            </div>

            {/* Filtered Events Card */}
            {/* <div className="bg-brand-light rounded-lg p-4 border border-brand">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-sm font-medium text-gray-600">Filtered Events</p>
                        <p className="text-3xl font-bold text-gray-900 mt-1">{filteredEvents}</p>
                    </div>
                    <div className="p-2 bg-brand-light rounded-lg">
                        <Filter className="w-6 h-6 text-brand" />
                    </div>
                </div>
            </div> */}

            {/* Total States Card */}
            <div 
                className="bg-brand-light rounded-lg p-4 border border-brand cursor-pointer hover:shadow-md transition-shadow"
                onClick={onStatesCardClick}
            >
                <div className="flex items-center justify-between">
                    <div>
                        <div className="flex items-center gap-1">
                            <p className="text-sm font-medium text-gray-600">Total States</p>
                            <div className="group relative inline-block" onClick={(e) => e.stopPropagation()}>
                                <Info className="w-4 h-4 text-gray-500 cursor-help hover:text-gray-700 transition-colors" />
                                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 hidden group-hover:block z-50 pointer-events-none">
                                    <div className="bg-gray-900 text-white text-xs rounded-lg py-2 px-3 w-64 shadow-xl">
                                        <p>Indicates the number of states where face authentication–based attendance has been enabled and attendance recording has been initiated.</p>
                                        <div className="absolute top-full left-1/2 transform -translate-x-1/2 -mt-1">
                                            <div className="border-4 border-transparent border-t-gray-900"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p className="text-3xl font-bold text-gray-900 mt-1">{totalStates}</p>
                    </div>
                    <div className="p-2 bg-brand-light rounded-lg">
                        <MapPin className="w-6 h-6 text-brand" />
                    </div>
                </div>
            </div>

            {/* Total Districts Card */}
            {/* <div className="bg-brand-light rounded-lg p-4 border border-brand">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-sm font-medium text-gray-600">Total Districts</p>
                        <p className="text-3xl font-bold text-gray-900 mt-1">{totalDistricts}</p>
                    </div>
                    <div className="p-2 bg-brand-light rounded-lg">
                        <Map className="w-6 h-6 text-brand" />
                    </div>
                </div>
            </div> */}
        </div>
    );
};

